"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _menu = require("./utils/menu");

/**
 * 数据源关系类
 */
var Relation = /*#__PURE__*/function () {
  function Relation(globalRelationList) {
    (0, _classCallCheck2["default"])(this, Relation);

    /**
     * 无极2.0定义的表关系集
     * [
     *   {
     *     "mainField": "role",
     *     "mainTable": "ly_test1.users",
     *     "forkField": "id",
     *     "forkTable": "ly_test1.roles",
     *     "isReverse": true,                  // 是否反向索引，即无极1.0 link关联
     *     "rel": "1",                         // 1:1 或 1:n
     *     "split": ","                        // 反向索引的分隔符，即无极1.0 link关联的存储分隔符
     *   }
     * ]
     */
    this.globalRelationList = globalRelationList;
  }
  /**
   * 获取tableKey表的所有forkTableKeys表集的关系对象集
   * @param {*} tableKey
   */


  (0, _createClass2["default"])(Relation, [{
    key: "getRelationList",
    value: function getRelationList(table) {
      var forkTableKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var tableKey = table.key;
      var _primaryKey = table._primaryKey; // 找出包含tableKey，另外一个必须是forkTableKeys存在的关系对象

      var allRelationList = this.globalRelationList.filter(function (item) {
        return item.mainTable === tableKey || item.forkTable === tableKey;
      }).filter(function (item) {
        return forkTableKeys.indexOf(item.mainTable) > -1 || forkTableKeys.indexOf(item.forkTable) > -1;
      }); // 以tableKey为视角，找出与其关联 + 存在于forkTableKeys的关系链

      return allRelationList.map(function (item) {
        var relationType;
        var keyStr;
        var relation = []; // 比如X.id = Y.xid or [X.id, ...] = Y.xids(link关联)，则Y存储关联键值：要通过_primaryKey判断到底哪个是X
        // 暂不考虑X、Y的关联键是非主键的，那我都不知道谁存储关联键值了

        if (item.mainTable === tableKey) {
          if (item.isReverse) {
            // link关联
            relationType = item.mainField === _primaryKey ? _menu.RelationStatus.IN : _menu.RelationStatus.INCLUDE;
          } else {
            // 非link关联
            relationType = item.mainField === _primaryKey ? _menu.RelationStatus.RIGHT : _menu.RelationStatus.LEFT;
          }

          keyStr = item.forkTable;
          relation = [item.mainField, relationType, item.forkField];
        } else {
          if (item.isReverse) {
            // link关联
            relationType = item.forkField === _primaryKey ? _menu.RelationStatus.IN : _menu.RelationStatus.INCLUDE;
          } else {
            // 非link关联
            relationType = item.forkField === _primaryKey ? _menu.RelationStatus.RIGHT : _menu.RelationStatus.LEFT;
          }

          keyStr = item.mainTable;
          relation = [item.forkField, relationType, item.mainField];
        }

        var keys = keyStr.split('.');
        return {
          key: keyStr,
          appId: keys[0],
          schemaId: keys[1],
          relation: relation,
          ratio: item.rel,
          isReverse: item.isReverse,
          split: item.split
        };
      });
    }
  }]);
  return Relation;
}();

var _default = Relation;
exports["default"] = _default;